<template>
  <main class="main">
    <Content />
    <StoreLinks />
  </main>
</template>

<script>
  import Content from './Content';
  import StoreLinks from './StoreLinks';

  export default {
    name: 'Main',
    components: {
      StoreLinks,
      Content
    }
  };
</script>

<style scoped></style>
